import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { tasksAPI } from '../../api/client';

// Статистика игр по одному заданию.
// Формат игры с бэка: { id, name, playedAt (ISO-дата), durationSeconds }
export const fetchGameStats = createAsyncThunk('gameStats/fetch', async (taskId) => {
    const response = await tasksAPI.getGames(taskId);
    return response.data;
});

const gameStatsSlice = createSlice({
    name: 'gameStats',
    initialState: {
        taskId: null,
        games: [],
        status: 'idle', // idle | loading | succeeded | failed
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchGameStats.pending, (state, action) => {
                state.taskId = action.meta.arg;
                state.games = [];
                state.status = 'loading';
            })
            .addCase(fetchGameStats.fulfilled, (state, action) => {
                if (action.meta.arg !== state.taskId) return; // ответ по другому заданию
                state.games = Array.isArray(action.payload) ? action.payload : [];
                state.status = 'succeeded';
            })
            .addCase(fetchGameStats.rejected, (state, action) => {
                if (action.meta.arg !== state.taskId) return;
                state.status = 'failed';
            });
    },
});

export default gameStatsSlice.reducer;
